// src/utils/form/formQuestions.js

export const questions = [
  {
    id: "id",
    titleKey: "id.title",
    fieldType: "text",
    required: false,
    repeatable: false,
    group: "metadata",
  },
  {
    id: "clinicStudyId",
    titleKey: "clinicStudyId.title",
    fieldType: "text",
    required: false,
    repeatable: false,
    group: "metadata",
  },
  {
    id: "height",
    titleKey: "height.title",
    fieldType: "number",
    required: true,
    repeatable: true,
    group: "metadata",
  },
  {
    id: "weight",
    titleKey: "weight.title",
    fieldType: "number",
    required: true,
    repeatable: true,
    group: "metadata",
  },
  {
    id: "chestCircumference",
    titleKey: "chestCircumference.title",
    fieldType: "number",
    required: true,
    repeatable: true,
    group: "metadata",
    descriptionKey: "chestCircumference.desc",
    resourceUrl:
      "https://firebasestorage.googleapis.com/v0/b/pdx-web-v2.firebasestorage.app/o/metadata_form_assets%2Fchest_measurement.PNG?alt=media&token=8266715a-b1a8-4a64-a723-65b5eda7a092",
    description:
      "Measure your chest circumference at the topmost part of the chest - directly under the underarms and above the bust - keeping the tape level around your torso and snug without compressing the chest.",
  },
  {
    id: "dateOfBirth",
    titleKey: "dateOfBirth.title",
    fieldType: "date",
    required: true,
    repeatable: false,
    group: "metadata",
  },
  {
    id: "sexAtBirth",
    titleKey: "sexAtBirth.title",
    fieldType: "select",
    required: true,
    options: [
      { value: "Female", labelKey: "sexAtBirth.opt.female" },
      { value: "Male", labelKey: "sexAtBirth.opt.male" },
    ],
    repeatable: false,
    group: "metadata",
  },
  {
    id: "ethnicity",
    titleKey: "ethnicity.title",
    fieldType: "select",
    required: true,
    options: [
      { value: "Caucasian", labelKey: "ethnicity.opt.white" },
      { value: "Black", labelKey: "ethnicity.opt.black" },
      { value: "North East Asian", labelKey: "ethnicity.opt.neAsian" },
      { value: "South East Asian", labelKey: "ethnicity.opt.seAsian" },
      { value: "Other", labelKey: "ethnicity.opt.other" },
    ],
    repeatable: false,
    group: "metadata",
  },
  {
    id: "respiratoryConditions",
    titleKey: "respiratoryConditions.title",
    fieldType: "select",
    required: true,
    repeatable: false,
    options: [
      { value: "none", labelKey: "respiratoryConditions.opt.none" },
      { value: "ild", labelKey: "respiratoryConditions.opt.ild" },
      { value: "copd", labelKey: "respiratoryConditions.opt.copd" },
      { value: "asthma", labelKey: "respiratoryConditions.opt.asthma" },
      {
        value: "copd_asthma",
        labelKey: "respiratoryConditions.opt.copd_asthma",
      },
    ],
    group: "metadata",
  },

  // Smoking Questions
  {
    id: "smoking",
    titleKey: "smoking.title",
    fieldType: "select",
    required: true,
    options: [
      { value: "never", labelKey: "smoking.opt.never" },
      { value: "former", labelKey: "smoking.opt.former" },
      { value: "current", labelKey: "smoking.opt.current" },
      { value: "ecigarette", labelKey: "smoking.opt.ecigarette" },
    ],
    repeatable: true,
    group: "metadata",
  },

  // Ex-smoker follow-up questions:
  {
    id: "yearsSinceQuit",
    titleKey: "yearsSinceQuit.title",
    fieldType: "select",
    required: true,
    options: [
      { value: "lessThan1month", labelKey: "yearsSinceQuit.opt.lt1m" },
      { value: "1-6months", labelKey: "yearsSinceQuit.opt.1_6m" },
      { value: "6-12months", labelKey: "yearsSinceQuit.opt.6_12m" },
      { value: "1-5years", labelKey: "yearsSinceQuit.opt.1_5y" },
      { value: "moreThan5years", labelKey: "yearsSinceQuit.opt.gt5y" },
    ],
    condition: (data) => data.smoking === "former",
    repeatable: true,
  },
  {
    id: "exQuitEffect",
    titleKey: "exQuitEffect.title",
    fieldType: "range",
    required: false,
    min: 0,
    max: 10,
    step: 1,
    rangeDescriptionKey: "exQuitEffect.desc",
    condition: (data) => data.smoking === "former",
    repeatable: true,
  },
];
